import statusCounters from '../websockets/types/counters-names';

export default {
  getCountOfOrdersWithNoActiveProviders(state, getters, rootState, rootGetters) {
    return Number(rootGetters['websockets/statusesCounters']
      .find((websocketObj) => websocketObj.name === statusCounters.orderWithNoActiveProviders).value);
  },
};
